import React from "react";
import TestimonialCard from "./TestimonialCard";

const testimonials = [
  // same testimonial data as before...
  {
    name: "Dr. Zahurul Islam Mickey",
    review:
      "I recently had the pleasure of working with JK Associates to complete my tax return and I was impressed with their service. From start to finish, their team demonstrated exceptional professionalism, efficiency, and expertise.",
    time: "2 months ago",
    imgUrl:
      "https://lh3.googleusercontent.com/a/ACg8ocJZZEwxTWM9lvjwPb0sx4qpTy8CWZ6v5hwBu_Zs3Vzgm16pPg",
    rating: 5,
  },
  {
    name: "Chathuri Kalpana Weerasinghe",
    review:
      "My experience with JK Associates was a very positive one. Their service was very professional and swift. Highly recommend JK Associates, especially for foreign nationals working in Bangladesh who look for trusted tax consultants.",
    time: "1 year ago",
    imgUrl:
      "https://lh3.googleusercontent.com/a-/ALV-UjXkSLvX7JX6zPnKrlzx3dGk9ApOaXPS02zqqarhNbgBh_0iLzc",
    rating: 4,
  },
  {
    name: "Girraj Agrawal",
    review:
      "Your exceptional work not only demonstrated a deep understanding of our needs but also showcased a level of commitment and passion that truly touched our hearts. Your contributions have been invaluable, and we're grateful for the positive impact you've had on our endeavors.",
    time: "8 months ago",
    imgUrl:
      "https://lh3.googleusercontent.com/a/ACg8ocLQ7VqfUJq9bYag78crZSs7ndO_hyvbGRbRs0m__MmZ0LknNw",
    rating: 5,
  },
  {
    name: "Zawadkhan Washy",
    review:
      "One the best income tax consultancy firm in Bangladesh. They take care of my income tax file. Highly Recommend.",
    time: "1 year ago",
    imgUrl:
      "https://lh3.googleusercontent.com/a/ACg8ocLNX1Zr3xmQDYB2ChToGaUSDu_dufqw-2kSNEUeIgDT2L101w=w36-h36-p-rp-mo-br100",
    rating: 4,
  },
  {
    name: "Masum Billah",
    review:
      "JK Associates has done an amazing job for my brand Trademark ™️ and ©️ copyright registration. They are very helpful, knowledgeable and extremely wonderful to work with! I will only use JK Associates for any legal work that I need.",
    time: "3 years ago",
    imgUrl:
      "https://lh3.googleusercontent.com/a-/ALV-UjWHVxr4-unig4ehwoyiaju6zgfYMO9G2KbbBUwaRES4ew8-FsUQ",
    rating: 5,
  },
  {
    name: "Mohosin Saikat",
    review:
      "It's a nice organisation. I am happy to work with them. I made my company's registration and other services.",
    time: "5 months ago",
    imgUrl:
      "https://lh3.googleusercontent.com/a-/ALV-UjVmYZJfH51H3IGXNlQUKc2HFGlX4mIF37dFFDyH7bS-z7QItBuLUQ=s120-c-rp-mo-br100",
    rating: 4,
  },
];

// Helper to group testimonials in groups of 3
function chunkArray(arr, size) {
  const chunks = [];
  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size));
  }
  return chunks;
}

export default function Testimonial() {
  const groupedTestimonials = chunkArray(testimonials, 3);
  const doubledGroups = [...groupedTestimonials, ...groupedTestimonials];

  const rowHeight = 320; // height of one testimonial row (adjust if needed)
  const totalHeight = rowHeight * groupedTestimonials.length; // total height to scroll

  // Animation duration (seconds) - control speed here
  // Faster scroll = smaller duration; slower scroll = bigger duration
  const durationSeconds = (totalHeight / 30) * 2; // example speed: 30px/s times 2 for smoother

  return (
    <>
      {/* Keyframes style */}
      <style>
        {`
          @keyframes scrollUp {
            0% {
              transform: translateY(0);
            }
            100% {
              transform: translateY(-${totalHeight}px);
            }
          }
        `}
      </style>

      <div
        style={{
          overflow: "hidden",
          height: `${rowHeight}px`,
          width: "100%",
          boxSizing: "border-box",
          borderRadius: "20px",
          padding: "10px 0",
          backgroundColor: "#F9F8F8",
          position: "relative",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            animation: `scrollUp ${durationSeconds}s linear infinite`,
          }}
        >
          {doubledGroups.map((group, idx) => (
            <div
              key={idx}
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "20px",
              }}
            >
              {group.map((item, i) => (
                <div
                  key={i}
                  style={{
                    flex: "0 0 300px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <TestimonialCard
                    item={item}
                    title="Client Testimonial"
                    showStars={true}
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
